<template>
    <multi-page-item-settings
        items-array-name="speakers"
        :settings="form"
        :item-creator-function="createEmptyItem"
        :default-close-handler="defaultCloseHandler"
    >
        <template slot-scope="{ edit, save, close, create, restore, selectedItem }">
            <wall-speakers-block-general-settings
                key="general-settings"
                :form="form"
                @edit-item="edit"
                @create-item="create"
            ></wall-speakers-block-general-settings>

            <wall-speakers-block-item-settings
                key="item-settings"
                :event="event"
                :block="block"
                :item="selectedItem"
                @save-settings="save"
                @cancel="restore"
            ></wall-speakers-block-item-settings>
        </template>
    </multi-page-item-settings>
</template>

<script>
import BlockableSettingsMixin from '@/mixins/BlockableSettingsMixin';
import HasDefaultCloseHandler from '@/mixins/HasDefaultCloseHandler';

export default {
    name: 'WallSpeakersBlockSettings',

    mixins: [HasDefaultCloseHandler, BlockableSettingsMixin],

    methods: {
        createEmptyItem () {
            return {
                name: '',
                description: '',
                images: [],
                active: true,
                new: true,
                includeUrl: false,
                url: '',
                buttonText: '',
                deletable: true
            };
        }
    }
};
</script>
